module.exports = __webpack_public_path__ + "img/estonia.5eb600b0.svg";